import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { ConfirmationDialog, ConfirmationMessageComponent } from '../../comman-components/confirmation-message/confirmation-message.component';
import { MasterService } from '../master.service';
import { ContractorDialogComponent } from './contractor-dialog/contractor-dialog.component';
import { debounceTime, distinctUntilChanged, map, startWith, Subscription, switchMap } from 'rxjs';
import { FormControl } from '@angular/forms';

export interface PeriodicElement {
  contactPerson: string;
  contactPersonNo: string;
  contractorName: number;
  emailId: string;
}
@Component({
  selector: 'app-contractor',
  templateUrl: './contractor.component.html',
  styleUrls: ['./contractor.component.scss']
})
export class ContractorComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  public displayedColumns = ['position','action','contractorName', 'contactPersonNo','emailId','state','panNo','status'];
  dataSource = new MatTableDataSource<PeriodicElement>();
  messageTitle: string;
  status: string;
  constructor(private masterService: MasterService, public dialog: MatDialog, private snackBar: MatSnackBar) { }

  ngOnInit(): void {
    // this.getContratorData();
  }

  totalData:any;
  searchControl = new FormControl('');
  subscription: Subscription;
  isContractorSaveInProgress = false;

  // getContratorData() {
  //   this.masterService.getAllContractor().subscribe(res => {
  //     this.dataSource.data = res;
  //     this.dataSource.paginator = this.paginator;
  //   });
  // }

  ngAfterViewInit() {
    
    this.dataSource.paginator = this.paginator;

    this.paginator.page
      .pipe(
        startWith({}),
        switchMap(() => {
          if(this.searchControl.value !== ''){
            return this.masterService.getContractorByPageCount({ page: this.paginator.pageIndex, searchText: this.searchControl.value});  
          }
          return this.masterService.getContractorByPageCount({ page: this.paginator.pageIndex });
        }),
        map((res) => {
          this.totalData = res.totalData;
          return res.data;
        })
      )
      .subscribe((data:any) => {
        this.dataSource = new MatTableDataSource(data);
      });

      this.subscription = this.searchControl.valueChanges
      .pipe(
        debounceTime(1000), // Waiting for 1 sec while you are typing
        distinctUntilChanged() // Prevents the emitting if the 'start' value and the 'end' value are the same
      )
      .subscribe(value => {
        console.log(value);
        // TODO: call BE here with this.httpClient...
        this.searchContrator(0, value);
      });
  }

  getContratorData(pageNumber: Number) {
    this.masterService.getContractorByPageCount({ page: this.paginator.pageIndex }).subscribe({
      next: (res) => {
        this.dataSource.data = res?.data;
        this.totalData = res?.totalData;
        // this.dataSource.paginator = this.paginator;
      },
      error: (error) => { }
    });
  }

  searchContrator(pageNumber: Number, search: string) {
    this.masterService.getContractorByPageCount({ page: pageNumber, searchText: search }).subscribe({
      next: (res) => {
        this.dataSource.data = res?.data;
        this.totalData = res?.totalData;
        this.dataSource.paginator = this.paginator;
      },
      error: (error) => { }
    });
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim();
  }

  // public createContractorDailog(userObj?) {
  //   let dialogRef = this.dialog.open(ContractorDialogComponent, {
  //     width: '600px',
  //     data: userObj
  //   });
  //   dialogRef.afterClosed().subscribe(data => {
  //     const payload = {
  //       "accountNo": data?.accountNo,
  //       "address": {
  //         "addressLine1": data.addressLine1,
  //         "addressLine2": data.addressLine2,
  //         "city": data.city,
  //         "district": data.district,
  //         "pincode": data.pincode,
  //         "state": data.state,
  //         "taluka": data.taluka
  //       },
  //       "contactPerson": data.contactPerson,
  //       "contactPersonNo": data.contactPersonNo,
  //       "contractorName": data.contractorName.trim(),
  //       "emailId": data.emailId,
  //       "ifscCode": data.ifscCode,
  //       "gstnumber": data.gstnumber,
  //       "panNo": data.panNo,
  //       "status": data.status,
  //       "tdsPer": data.tdsPer
  //     };
  //     (data.contractorKey) ? this.updateContractor(data.contractorKey, payload) : this.saveContractor(payload);
  //   });
  // }

  public createContractorDailog(userObj?) {

  if (this.isContractorSaveInProgress) {
    return;
  }

  this.isContractorSaveInProgress = true;

  let dialogRef = this.dialog.open(ContractorDialogComponent, {
    width: '600px',
    data: userObj
  });

  dialogRef.afterClosed().subscribe(data => {

    // User clicked Cancel
    if (!data) {
      this.isContractorSaveInProgress = false;
      return;
    }

    const payload = {
      accountNo: data.accountNo,
      address: {
        addressLine1: data.addressLine1,
        addressLine2: data.addressLine2,
        city: data.city,
        district: data.district,
        pincode: data.pincode,
        state: data.state,
        taluka: data.taluka
      },
      contactPerson: data.contactPerson,
      contactPersonNo: data.contactPersonNo,
      contractorName: data.contractorName.trim(),
      emailId: data.emailId,
      ifscCode: data.ifscCode,
      gstnumber: data.gstnumber,
      panNo: data.panNo,
      status: data.status,
      tdsPer: data.tdsPer
    };

    if (data.contractorKey) {
      this.updateContractor(data.contractorKey, payload);
    } else {
      this.saveContractor(payload);
    }

  });

}

  saveContractor(payload) {
      this.masterService.addNewContractorItem(payload).subscribe(res => {
        this.snackBar.open('New Contractor added successfully!', 'Cancel', {
          duration: 3000, verticalPosition: 'top', panelClass: ['if-success']
        });
        this.getContratorData(0);
        this.isContractorSaveInProgress = false;
      },
        (error) => {
          if (error) {
            this.isContractorSaveInProgress = false;
            this.snackBar.open(error, 'Cancel', {
              duration: 3000, verticalPosition: 'top', panelClass: ['if-error']
            });
          }
        }
      )
  }

  updateContractor(contractorKey, payload) {
      this.masterService.updateContractorItem(contractorKey, payload).subscribe(res => {
        this.snackBar.open('Updated contractor successfully!', 'Cancel', {
          duration: 3000, verticalPosition: 'top', panelClass: ['if-success']
        });
        this.getContratorData(0);
        this.isContractorSaveInProgress = false;
      },
        (error) => {
          if (error) {
            this.isContractorSaveInProgress = false;
            this.snackBar.open(error, 'Cancel', {
              duration: 3000, verticalPosition: 'top', panelClass: ['if-error']
            });
          }
        }
      )
  }

  toggleContractorStatus(element: any): void {

  const newStatus = element.status === 'ACTIVE'
    ? 'INACTIVE'
    : 'ACTIVE';

  const data: ConfirmationDialog = {
    title: 'Contractor Status Confirmation',
    message: `Are you sure you want to ${newStatus === 'ACTIVE' ? 'Activate' : 'Deactivate'} Contractor?`,
    yes: 'Yes',
    no: 'No'
  };

  const dialogRef = this.dialog.open(ConfirmationMessageComponent, {
    width: '400px',
    height: '200px',
    position: { top: '200px' },
    data
  });

  dialogRef.afterClosed().subscribe(result => {

    if (!result) {
      return;
    }

    this.masterService
      .deleteContractor(element.contractorKey, newStatus)
      .subscribe({

        next: (res: any) => {

          element.status = newStatus;

          this.snackBar.open(res.message, 'Close', {
            duration: 3000,
            verticalPosition: 'top',
            panelClass: ['if-success']
          });

        },

        error: (err) => {
          this.isContractorSaveInProgress = false;

          this.snackBar.open(err, 'Close', {
            duration: 3000,
            verticalPosition: 'top',
            panelClass: ['if-error']
          });

        }

      });

  });

}

  // deleteContractor(id, status) {
  //   if(status === 'ACTIVE'){
  //           this.messageTitle = ' Are you sure you want to Deactivate Contractor';
  //     this.status = 'INACTIVE';
  //   } else {
  //          this.messageTitle = ' Are you sure you want to Activate Contractor';
  //      this.status = 'ACTIVE'
  //   }
  //   let Data:ConfirmationDialog = {
  //     title:'Contractor Status  Confirmation',
  //     message: this.messageTitle,
  //     yes: 'Yes',
  //     no: 'No'
  //   }
  //   const dialogRef = this.dialog.open(ConfirmationMessageComponent, {
  //     width: '400px',
  //     height: '200px',
  //     position: { top: '200px' },
  //     data: Data
  //   });
  //   dialogRef.afterClosed().subscribe((result) => {
  //     if (result) {
  //       this.masterService.deleteContractor(id, this.status).subscribe(res => {
  //         this.snackBar.open(res.message, 'Cancel', {
  //           duration: 3000, verticalPosition: 'top', panelClass: ['if-success']
  //         });
  //         this.getContratorData(0);
  //       },
  //         (error) => {
  //           if (error) {
  //             this.snackBar.open(error, 'Cancel', {
  //               duration: 5000, verticalPosition: 'top', panelClass: ['if-error']
  //             });
  //           }
  //         });
  //     }
  //   });
  // }

  numbersFun(index: number): number {
    return index + 1 + (this.paginator.pageIndex * this.paginator.pageSize);
  }
}
